import type { FC } from "react";
import { useTranslation } from "react-i18next";

import type { Entity } from "../../core/types/fe/Entity";
import { ButtonEvents } from "../Buttons/ButtonEvents";
import { GenericConfirmationSecondaryButton } from "../Buttons/components/GenericConfirmationSecondaryButton";

export type CopyButtonProps = {
    isDisabled: boolean;
    callback?: (itemToCopy: object) => void;
    itemToCopy: Entity;
};

export const CopyButton: FC<CopyButtonProps> = ({ isDisabled, callback, itemToCopy }) => {
    const { t } = useTranslation();

    return (
        <GenericConfirmationSecondaryButton
            name="CopyButton"
            isDisabled={isDisabled}
            onClickCallback={() => {
                if (callback) {
                    callback(itemToCopy);
                }
                return itemToCopy;
            }}
            item={itemToCopy}
            modalTitle={t("genericTable.copyModal.title")}
            modalBody={t("genericTable.copyModal.message")}
            translationKey="button.copy"
            onClickEventName={ButtonEvents.ADD}
            className="aevi-button aevi-button-secondary"
        />
    );
};
